import React, { useState } from "react";
import {
  Button,
  DevNote,
  FormFieldSet,
  Modal,
  NewTab,
  PageTabAdv,
  useFormHandler,
} from "../../../../components";
import { useLocation, useNavigate } from "react-router-dom";
import CampaignName from "./AddNewCampaign/CampaignName";
import Leads from "./AddNewCampaign/Leads";
import Sequences from "./AddNewCampaign/Sequences";

import Options from "./AddNewCampaign/Options";
import Schedule from "./AddNewCampaign/Schedule";
import { useModuleAccess } from "../../../../hooks";

const AddCampaign = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isEdit = location.state?.isEdit;

  const addApplicantMenus = [
    !isEdit &&{
      title: "Campaign Name",
      page: <CampaignName />,
      type: "main",
      id: "campaignsaddcampaign_campaignname",
    },
    {
      title: "Leads",
      page: <Leads />,
      type: "main",
      id: "campaignsaddcampaign_leads",
    },
    {
      title: "Sequences",
      page: <Sequences />,
      type: "main",
      id: "campaignsaddcampaign_sequences",
    },
    {
      title: "Schedule",
      page: <Schedule />,
      type: "main",
      id: "campaignsaddcampaign_schedule",
    },
    {
      title: "Options",
      page: <Options />,
      type: "main",
      id: "campaignsaddcampaign_options",
    },
  ];
  const filteredTabs = useModuleAccess({
    allTabs: addApplicantMenus,
    parentId: "campaignsaddcampaign",
  });

  return (
    <div>
      <Button
        title="Add New Campaign"
        color="black"
        variant="text"
        size="md"
        fromLeft
        icon="arrow_left_alt"
        className="self-start text-md font-semibold"
        onClick={() => {
          navigate("/ats/campaigns");
        }}
      />
      <NewTab
        tabs={filteredTabs}
        color="gray"
        variant="text"
        activeVariant="text"
        mode="url"
        tabId="add-campaign"
      />
    </div>
  );
};

export default AddCampaign;
